import React, { useState } from 'react';
import { ProjectDocumentAttachmentView } from 'app/edozvola/cases/project-documents/model/project-documents.model';
import { convertDateFromServer } from 'app/shared/util/date-utils';
import ViewTableHeaderColumn from 'app/shared/view-table/view-table-header-column';
import {
  deleteProjectDocumentAttachmentQuery,
  fetchProjectDocumentAttachmentsQuery,
  updateProjectDocumentAttachmentStatusQuery,
} from 'app/edozvola/cases/project-documents/service/project-document.queries';
import { Button } from 'edozvola-frontend-lib/dist/ui/components';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import ManagableTable from 'app/shared/view-table/managable-table';
import { previewProjectDocumentAttachment } from 'app/edozvola/cases/project-documents/service/project-document.service';
import { FileWrapper } from 'app/shared/model/shared.model';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getCaseContext } from 'app/shared/util/context-util';
import { ENTITY_TYPE } from 'app/shared/digital-signature/digital-signature.model';
import SignerListModal from 'app/shared/digital-signature/signer-list-modal';
import '../../../../shared/view-table/view-table.scss';
import { TooltipWrapper } from 'edozvola-frontend-lib/dist/ui/components/tooltipwrapper';
import { openFileInNewWindow } from 'app/shared/util/navigation-util';
import {faCircleNotch} from "@fortawesome/free-solid-svg-icons";

const ProjectDocumentAttachmentsTable = ({ idProjectDocument }) => {
  const [idProjectDocumentAttachmentToDelete, setIdProjectDocumentAttachmentToDelete] = useState();
  const [deleteModalShown, setDeleteModalShown] = useState(false);
  const { sidebarItemPair } = getCaseContext();
  const [signerListOpen, setSignerListOpen] = useState(false);
  const [idProjectDocumentAttachmentSigners, setIdProjectDocumentAttachmentSigners] = useState<number>(null);
  const [previewAttachmentPendingAttachmentId, setPreviewAttachmentPendingAttachmentId] = useState<number>(null);

  const { mutate: deleteMutation, isPending: isDeleting } = deleteProjectDocumentAttachmentQuery();
  const { mutate: changeStatusMutation, isPending: isChangingStatus } = updateProjectDocumentAttachmentStatusQuery();

  const openDeleteDialog = idToDelete => {
    setIdProjectDocumentAttachmentToDelete(idToDelete);
    setDeleteModalShown(true);
  };

  const openFileInNewTable = idProjectDocumentAttachment => {
    setPreviewAttachmentPendingAttachmentId(idProjectDocumentAttachment);
    previewProjectDocumentAttachment(idProjectDocumentAttachment).then((document: FileWrapper) => {
      if (document) {
        openFileInNewWindow(document.url)
      }
    })
      .finally(() => setPreviewAttachmentPendingAttachmentId(null));
  };

  const openSignerListModal = (value: number) => {
    setIdProjectDocumentAttachmentSigners(value);
    setSignerListOpen(true);
  };

  const renderTableRow = (value: ProjectDocumentAttachmentView, projectDocumentAttachmentIndex: number, setFieldValue) => {
    return (
      <tr key={projectDocumentAttachmentIndex}>
        <td>
          <span>{value.name}</span>
        </td>
        <td>
          <span>{convertDateFromServer(value.createdDate)}</span>
        </td>
        <td>{value.lastSignerInstitution}</td>
        <td>
          <span>{value.lastValidSignature}</span>
        </td>
        <td>{value.status ? 'Aktivan' : 'Neaktivan'}</td>
        <td>
          <div className={'actions-container'}>
            {sidebarItemPair?.canViewDocument && (
              <TooltipWrapper message={'Pregledaj dokument'}>
                {previewAttachmentPendingAttachmentId === value.idProjectDocumentAttachment ?
                  <FontAwesomeIcon
                    icon={faCircleNotch}
                    className={'icon-table'}
                    spin={true}
                  /> :
                  <FontAwesomeIcon
                    icon={'file'}
                    className={'icon-table'}
                    aria-disabled={previewAttachmentPendingAttachmentId != null}
                    onClick={previewAttachmentPendingAttachmentId ? () => {} : () => openFileInNewTable(value.idProjectDocumentAttachment)}
                  />
                }
              </TooltipWrapper>
            )}
            {sidebarItemPair?.canViewSignatures && value.lastValidSignature !== null && value.lastValidSignature !== '' && (
              <TooltipWrapper message={'Pregledaj potpise'}>
                <FontAwesomeIcon
                  icon={'file-alt'}
                  className={'icon-table'}
                  aria-disabled={previewAttachmentPendingAttachmentId != null}
                  onClick={previewAttachmentPendingAttachmentId ? () => {} : e => openSignerListModal(value.idProjectDocumentAttachment)}
                />
              </TooltipWrapper>
            )}
            {sidebarItemPair?.canDelete && value.canDelete && (
              <TooltipWrapper message={'Obriši'}>
                <FontAwesomeIcon
                  icon={'trash-alt'}
                  className={'icon-table'}
                  aria-disabled={previewAttachmentPendingAttachmentId != null}
                  onClick={previewAttachmentPendingAttachmentId ? () => {} : () => openDeleteDialog(value.idProjectDocumentAttachment)}
                />
              </TooltipWrapper>
            )}
          </div>
        </td>
      </tr>
    );
  };

  const deleteAttachment = () => {
    deleteMutation(idProjectDocumentAttachmentToDelete);
    setDeleteModalShown(false);
  };

  return (
    <>
      <ManagableTable
        renderTableRow={renderTableRow}
        noDataMessage={'Nema priloga'}
        initialPaginationColumn={'name'}
        fetchDataQuery={fetchProjectDocumentAttachmentsQuery}
        fetchDataProps={[idProjectDocument]}
      >
        <ViewTableHeaderColumn renderSort sortKey={'name'} columnLabels={['Naziv priloga']} width={'200px'} />
        <ViewTableHeaderColumn renderSort sortKey={'createdDate'} columnLabels={['Datum unosa']} width={'100px'} />
        <ViewTableHeaderColumn
          renderSort
          sortKey={'lastValidSignature'}
          columnLabels={['Institucija zadnjeg potpisnika']}
          width={'150px'}
        />
        <ViewTableHeaderColumn renderSort sortKey={'lastSignerInstitution'} columnLabels={['Zadnji validni potpis']} width={'150px'} />
        <ViewTableHeaderColumn renderSort sortKey={'status'} columnLabels={['Status']} width={'90px'} />
        <ViewTableHeaderColumn renderSort={false} columnLabels={['Akcije']} width={sidebarItemPair?.readOnly ? '50px' : '100px'} />
      </ManagableTable>
      <Modal scrollable isOpen={deleteModalShown} size={'lg'} toggle={() => setDeleteModalShown(false)} centered>
        <ModalHeader>
          <span>Brisanje priloga</span>
        </ModalHeader>
        <ModalBody>
          <div>Jeste li sigurni da želite obrisati podatke?</div>
        </ModalBody>
        <ModalFooter>
          <Button size={'lg'} label="Odustani" outline onClick={() => setDeleteModalShown(false)} color={'secondary'} />
          <Button size={'lg'} label="Obriši" onClick={deleteAttachment} color={'danger'} />
        </ModalFooter>
      </Modal>
      {signerListOpen && (
        <SignerListModal
          entity={ENTITY_TYPE.PROJECT_DOCUMENT_ATTACHMENT}
          idEntity={idProjectDocumentAttachmentSigners}
          onClose={() => setSignerListOpen(false)}
        />
      )}
    </>
  );
};

export default ProjectDocumentAttachmentsTable;
